import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import insertScript from '../../../assets/scripts/utilities/insert-script.js'

const getSeamlyToken = () =>
  fetch(`?accnr=${getAccountNumber()}`)
    .then(response => response.token)
    .catch(error => console.log(error))

const getAccountNumber = () => parseInt(sessionStorage.getItem('accnr'), 10) ?? 0

class SeamlyChatEmbedComponent extends Component {
  init() {
    window.requestAnimationFrame(() => this.startObserver())
  }

  startObserver() {
    this.observer = new IntersectionObserver(entries => this.handleIntersect(entries), { root: null, rootMargin: '0px', threshold: [0, 1] })
    this.observer.observe(this.element)
  }

  async handleIntersect(entries) {
    if (!entries.some(entry => entry.isIntersecting)) {
      return
    }

    await this.initSeamly()
    this.observer.disconnect()
  }

  async initSeamly() {
    this.cookieNotice = this.element.querySelector('.cookie-notice')
    this.url = this.element.getAttribute('data-url')
    this.brand = this.element.getAttribute('data-brand')
    this.placeholder = this.element.querySelector('.seamly-placeholder')

    if (!this.url || !this.brand || !this.placeholder || !this.cookieNotice) {
      return
    }

    this.cookieCategory = this.cookieNotice.getAttribute('data-category') || ''
    this.consentRun = false
    this.consentTimeout = null
    this.consentTimeoutDelay = 250

    if (!this.cookieCategory) {
      return
    }

    window.addEventListener('cf_init', () => this.loadAfterCookieConsent())
    window.addEventListener('cf_update', () => this.loadAfterCookieConsent())
    window.addEventListener('cf_consent', () => {
      window.clearTimeout(this.consentTimeout)
      window.setTimeout(() => this.loadAfterCookieConsent(true), this.consentTimeoutDelay)
    })
  }

  async loadAfterCookieConsent(force = false) {
    if (!force && this.consentRun) {
      return
    }

    const consent = window.CookieFirst?.consent || {}

    // eslint-disable-next-line no-undef
    if (environment === 'development' || consent[this.cookieCategory]) {
      this.cookieNotice.setAttribute('hidden', 'hidden')
      await insertScript('seamly-chat-embed', this.url)
      this.initSeamlyInlineMode()
      this.consentRun = true
    }
  }

  initSeamlyInlineMode() {
    window.seamly = window.seamly || []

    const obj = {
      action: 'init',
      args: {
        layoutMode: 'inline',
        parentElement: this.placeholder,
        namespace: 'icscards-goldfield',
        hideOnNoUserResponse: true,
        brand: this.brand || 'ics',
        api: {
          getConversationAuthToken: getSeamlyToken,
        },
      },
    }

    window.seamly.push(obj)
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'seamly-chat-embed', SeamlyChatEmbedComponent))
